export default __webpack_public_path__ + "static/staff002-1f3f8565b4a81f2ac9d68914067bb230.png";